import React from "react";
import GlobalToolAccordion from "../GlobalToolAccordion";
import DisplayDesigns from "./DisplayDesigns";
import AddDesign from "./AddDesign";
import UpdateDesign from "./UpdateDesign";

/** What the update title reads off the design row DisplayDesigns hands to `handleUpdate` (typed unknown there). */
type DesignRow = { _id?: string; name?: string };

// SCRUM-2118: the accordion lives in GlobalToolAccordion; this screen is its configuration.
const DesignContainer = () => (
  <GlobalToolAccordion<unknown>
    headerName="Designs"
    listTitle="Available designs"
    readOnlyListTitle="Available Designs"
    noun="design"
    titleOf={(design) => (design as DesignRow).name}
    emptyElem={{}}
    renderList={(handleUpdate) => <DisplayDesigns handleUpdate={handleUpdate} />}
    renderCreate={(back) => <AddDesign switchToDesignListHandler={back} />}
    renderUpdate={(design, back) => <UpdateDesign design={design} switchToDesignListHandler={back} />}
  />
);

export default DesignContainer;
